<template>
    <div class="preloader-component">
        <div class="preloader" :class="(show) ? '' : 'fade-out'">
            <div class="preloader-container">
                <p><strong>Just a few seconds...</strong></p>
                <div class="progress">
                    <div class="chocolate" :style="{ left: `${progress}px`}">
                        <div style="position: fixed">
                            <img src="../assets/preloader.png" alt="Preloader icon" width="30px">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Preloader',
    data() {
        return {
            show: true,
            progress: -320
        }
    },
    methods: {
        progressData() {
            setInterval(() => {
                if (this.progress < 0) {
                    this.progress += 10
                }
            }, 100);
        },
        hideLoader() {
            setTimeout(() => {
                this.show = false;
            }, Math.floor(Math.random() * 2000) + 1000);
        },
    },
    beforeDestroy() {
        clearInterval(this.progress);
    },
    created() {
        this.progressData();
    },
    mounted() {
        this.hideLoader();
    }
}
</script>

<style lang="sass" scoped>
.fade-out
    visibility: hidden
    opacity: 0
    transition: visibility 0s 2s, opacity 2s linear
.preloader
    position: fixed
    left: 0
    top: 0
    width: 100%
    height: 100%
    z-index: 102
    text-align: center
    color: $white
    text-transform: uppercase
    background-color: $dutche-primary-violet
    .preloader-container
        width: 320px
        height: 200px
        position: absolute
        top: 0
        bottom: 0
        left: 0
        right: 0
        margin: auto
    .chocolate
        position: relative
        background-color: $dutche-primary-yellow
        width: 100%
        border-radius: inherit
    .chocolate img
        position: absolute
        top: -10px
        left: 290px
</style>
